// Champs envoyés au serveur : seulement ceux qui changent (une modification ne doit pas écraser ce que la
// gouvernance a changé entre-temps, ni effacer un champ absent du formulaire comme la couleur).
export const CIRCLE_FIELDS = [
  'name', 'purpose', 'owner_id', 'owner_ids', 'reserved_domains', 'domains', 'accountabilities', 'strategy',
  'parent_id', 'color', 'vote_timeout_days',
];

const comparable = (field, value) => {
  if (field === 'owner_ids') return JSON.stringify([...(value || [])].map(Number).sort((a, b) => a - b));
  if (field === 'reserved_domains') return JSON.stringify([...(value || [])].sort());
  if (Array.isArray(value)) return JSON.stringify(value);
  if (field === 'owner_id' || field === 'parent_id') {
    return value === null || value === undefined || value === '' ? '' : String(Number(value));
  }
  return value === null || value === undefined ? '' : String(value).trim();
};

export const circlePatch = (current, next) => {
  const patch = {};
  CIRCLE_FIELDS.forEach((field) => {
    if (!(field in next)) return;
    if (comparable(field, next[field]) !== comparable(field, current?.[field])) patch[field] = next[field];
  });
  return patch;
};
